export const TechnicalGroupController = {
    index(): void {},
    show(): void {},
};
